import "../../css/footer.css";
import "../../css/container.css";
import "../../css/fonts.css";
import { useNavigate } from "react-router-dom";
export const FooterLinksLocalRest = () => {
  const navigate = useNavigate();

  return (
    <div className="footer-links-local">
      <div
        className={"title-text-font" + " " + " footer-text-link"}
        onClick={() => navigate("/")}
      >
        Home
      </div>
      <div
        className={"title-text-font" + " " + " footer-text-link"}
        onClick={() => navigate("/services")}
      >
        Our Services
      </div>
      <div
        className={"title-text-font" + " " + " footer-text-link"}
        onClick={() => navigate("/about")}
      >
        About
      </div>
    </div>
  );
};
// textAlign: "center",
